import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from 'ra-language-english';

const customEnglishMessages = {
    ...englishMessages,
    ra: {
        ...englishMessages.ra,
        action: {
            ...englishMessages.ra.action,
            add_filter: 'Saved lists',
        },
        saved_queries: {
            ...englishMessages.ra.saved_queries,
            remove_label: 'Remove saved lists',
            remove_label_with_name: 'Remove saved lists',
        },
    },
};

// Disable missing translation warnings
// https://marmelab.com/react-admin/Translation.html#silencing-translation-warnings
const i18nProvider = polyglotI18nProvider(
    () => customEnglishMessages,
    'en',
    {
        allowMissing: true,
        onMissingKey: (v) => v,
    },
);

export default i18nProvider;
